module.exports = __webpack_public_path__ + "static/media/shuttle-en2.bd3a44c1.png";